import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Mimic } from 'icreate/common/models/mimic';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MimicsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async create(
        name: string,
        userId: string,
        vesselId: string,
        index: number,
        folderId: string,
        channelGroup,
        profile?,
        svgcontent?
    ): Promise<Mimic> {
        const newMimic = {
            index,
            folderId,
            name,
            userId,
            vesselId,
            channelGroup,
            profile,
            svgcontent,
        };
        return await lastValueFrom(
            this.http.post<Mimic>(`${this.domain}/api/mimic`, newMimic, {
                headers: this.headers,
            })
        );
    }

    async update(mimic: Mimic, ignoreEmit: boolean = false) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/mimic/${mimic.id}`, { mimic, ignoreEmit }, { headers: this.headers })
        );
    }

    async delete(mimicId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/mimic/${mimicId}`));
    }

    async getMimic(mimicId): Promise<Mimic> {
        return await lastValueFrom(this.http.get<Mimic>(`${this.domain}/api/mimic/${mimicId}`));
    }

    async duplicate(mimic: Mimic, idMapping: Record<string, string>) {
        return await lastValueFrom(
            this.http.post<Mimic>(
                `${this.domain}/api/mimic/duplicate`,
                { mimic, idMapping },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async updateIndex(currentIndex: number, targetIndex: number, vesselId: string, folderId: string) {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/mimic/move`, {
                currentIndex,
                targetIndex,
                vesselId,
                folderId,
            })
        );
    }
}
